import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Box, 
  Tabs, 
  Tab, 
  useTheme
} from '@mui/material';
import { 
  NewLabel,
  Memory,
  Analytics,
  People
} from '@mui/icons-material';
import { useAuth } from '../shared/hooks/useAuth';
import HeaderMenu from './HeaderMenu';
import logoLight from '@/images/logo_light.png';

const Header = ({ currentView, onViewChange, showTabs = true }) => {
  const theme = useTheme();
  const { user } = useAuth();
  
  const handleLoginClick = () => {
    // If onViewChange exists and currentView is not login, switch to login
    if (onViewChange && currentView !== 'login') {
      onViewChange('login');
    }
  };

  const handleTabChange = (event, newValue) => {
    onViewChange(newValue);
  };

  const isAdmin = user?.is_admin === true;

  return (
    <AppBar 
      position="static" 
      elevation={0}
      sx={{ 
        backgroundColor: 'white',
        color: 'black',
        boxShadow: (theme) => theme.shadows[3], // Use theme shadow
        zIndex: (theme) => theme.zIndex.appBar // Proper z-index for AppBar
      }}
    >
      <Toolbar sx={{ 
        minHeight: `${theme.dimensions.panel.headerHeight}px !important`, 
        height: theme.dimensions.panel.headerHeight,
        transition: 'all 0.2s ease'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: theme.spacing(3) }}>
          <img 
            src={logoLight}
            alt="Qunova Logo" 
            style={{ 
              height: theme.dimensions.panel.headerHeight * 0.7,
              objectFit: 'contain',
              marginRight: theme.spacing(3)
            }} 
          />
          <Typography variant="body1" component="div" sx={{ 
            fontWeight: theme.typography.fontWeight.regular, 
            fontSize: theme.typography.fontSize.lg,
            letterSpacing: '0.1em',
            color: theme.palette.grey[600]
          }}>
            PROTIFY
          </Typography>
        </Box>
        
        {showTabs ? (
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <Tabs 
              value={currentView} 
              onChange={handleTabChange}
              sx={{ 
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontSize: theme.typography.fontSize.md,
                  fontWeight: theme.typography.fontWeight.medium,
                  minHeight: theme.dimensions.panel.headerHeight,
                  padding: theme.spacing(0.75, 2),
                  color: theme.palette.text.secondary,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: theme.spacing(0.5),
                  '&.Mui-selected': {
                    color: theme.palette.primary.main
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: theme.typography.fontSize.lg
                  }
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: theme.palette.primary.main,
                  height: 2
                }
              }}
            >
              <Tab 
                icon={<NewLabel sx={{ transform: 'rotate(45deg)' }} />} 
                label="Structures" 
                value="structures"
                iconPosition="start"
              />
              <Tab 
                icon={<Memory />} 
                label="Inputs" 
                value="computations"
                iconPosition="start"
              />
              <Tab 
                icon={<Analytics />} 
                label="Analysis" 
                value="analysis"
                iconPosition="start"
              />
              {isAdmin && (
                <Tab 
                  icon={<People />} 
                  label="Users" 
                  value="users"
                  iconPosition="start"
                />
              )}
            </Tabs>
          </Box>
        ) : (
          <Box sx={{ flexGrow: 1 }} />
        )}

        <HeaderMenu onLoginClick={handleLoginClick} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
